import { Stack } from '@mui/material';
import { ManagerUrlParamsFilter } from '../../../entities/filters/manager-url-params-filter';
import { DateUrlParamsFilter } from 'entities/filters/date-url-params-filter';
import { InputParamFilter } from 'shared/ui/param-filters/input-param-filter';
import { SimpleParamFilter } from 'shared/ui/param-filters/simple-param-filter';
import { CALL_TYPE_ARRAY } from '@sr/dto/dist/src/enums/events';
import { CompanyUrlParamsFilter } from 'entities/filters/company-url-params-filter';
import { FilterWrapper, ValueFormatterContext } from 'shared/ui/filter/filter-wrapper';
import { useManagersDropdownList } from 'features/user/user-picker/ui';
import { useSearchParams } from 'react-router-dom';
import { useCompanyLabel } from 'shared/hooks/use-entity-labels';

export const CallsFilter = () => {
  const CALL_TYPES = CALL_TYPE_ARRAY;
  const { items: managers } = useManagersDropdownList();
  const [searchParams] = useSearchParams();
  const selectedCompanyId = searchParams.get('companyId');
  const companyLabel = useCompanyLabel(selectedCompanyId);

  const managerFormatter = ({ value }: ValueFormatterContext) => {
    const manager = managers.find((m) => String(m.id) === value);
    return manager ? `${manager.firstName} ${manager.secondName || ''}`.trim() : value;
  };

  const companyFormatter = ({ value }: ValueFormatterContext) => {
    if (companyLabel && selectedCompanyId === value) return companyLabel;
    return value;
  };

  return (
    <FilterWrapper title="Фильтры звонков">
      <FilterWrapper.Item label="Телефон (от)" queryKeys="fromPhone">
        <InputParamFilter queryParamName="fromPhone" label="Телефон от" />
      </FilterWrapper.Item>

      <FilterWrapper.Item label="Телефон (куда)" queryKeys="toPhone">
        <InputParamFilter queryParamName="toPhone" label="Телефон куда" />
      </FilterWrapper.Item>

      <FilterWrapper.Item label="Компания" queryKeys="companyId" valueFormatter={companyFormatter}>
        <CompanyUrlParamsFilter queryParamName="companyId" />
      </FilterWrapper.Item>

      <FilterWrapper.Item label="Менеджер" queryKeys="userId" valueFormatter={managerFormatter}>
        <ManagerUrlParamsFilter queryParamName="userId" />
      </FilterWrapper.Item>

      <FilterWrapper.Item label="Длительность" queryKeys="atsDuration">
        <InputParamFilter queryParamName="atsDuration" label="Длительность от, сек" />
      </FilterWrapper.Item>

      <FilterWrapper.Item label="Направление" queryKeys="taskType">
        <SimpleParamFilter queryParamName="taskType" items={CALL_TYPES} label="Направление" />
      </FilterWrapper.Item>

      <FilterWrapper.Item
        label="Дата звонка"
        queryKeys={['startDate', 'endDate']}
        summaryFormatter={({ searchParams }) => {
          const from = searchParams.get('startDate');
          const to = searchParams.get('endDate');
          if (!from && !to) return 'Дата звонка';
          if (from && to) return `Звонок: ${from} — ${to}`;
          return `Звонок: ${from || to}`;
        }}
      >
        <Stack spacing={1.5}>
          <DateUrlParamsFilter queryParamName={'startDate'} label="Дата с" />
          <DateUrlParamsFilter queryParamName={'endDate'} label="Дата по" />
        </Stack>
      </FilterWrapper.Item>
    </FilterWrapper>
  );
};
